const IntlMessageFormat = require('intl-messageformat');

export default (label, values) => {
    if (!values) {
        return label;
    }
    try {
        const intlMessageFormat = new IntlMessageFormat(label);
        return intlMessageFormat.format(values);
    } catch (e) {
        return label;
    }
};
